
const state = [
	{
		id: 			"FOH680i9PqSO", 
		type: 			"poll",
		assessment: 	"HhoSAanfneFrKeASrw8",
		name: 			"Strukturen der Sektorenübergreifende Vernetzung", 
		status: 		"in_progress",
		message:		"Wir brauchen hier Antworten von Kollegen mit struktureller Erfahrung ", 
		members: 		["default", "colleague3"], 
		pinned: 		true, 
		response_count:	2,
		started_count:	0,
		responses: 		[],
		updated:       	"2020-09-29T12:28:00",		
		created:       	"2020-09-20T09:00:45",
	},
	{
		id: 			"oOpda534HBjJ8", 
		type: 			"poll",
		assessment: 	"HhoSAanfneFrKeASrw8",
		name: 			"Ergebnisse im klinischen Anwendungsfeld", 
		status: 		"in_progress",
		message:		"Bitte hier um Beitrag aus der Verwaltung", 
		members: 		["default"], 
		pinned: 		true, 
		response_count:	0,
		started_count:	0,
		responses: 		[],
		updated:       	"2020-09-29T12:28:00",		
		created:       	"2020-09-20T09:00:45",
	},
	{
		id: 			"4je6550lIiUh", 
		type: 			"delegation",
		status: 		"in_progress",
		completion_rate: 40,
		name: 			"Strukturen der Informationssicherheit / IT-Compliance",
		assessment: 	"HhoSAanfneFrKeASrw8",
		message:		"Bitte tragen Sie Ihre Porzesskenntnisse bei", 
		members: 		["colleague2"], 
		updated:        "2020-09-29T15:28:00",	
		created:        "2020-09-20T09:01:00"
	},
	{
		id: 			"72342fskeGD492", 
		type: 			"delegation",
		status: 		"in_progress",
		completion_rate: 90,
		name: 			"Ergebnisse im klinischen Anwendungsfeld",
		assessment: 	"HhoSAanfneFrKeASrw8",
		message:		"Was halten Sie hiervon? ", 
		members: 		["colleague3"], 
		updated:        "2020-09-28T13:44:12",
		created:       	"2020-09-20T08:58:53",
	},
	{
		id: 			"G6RbgSrIVX0x", 
		type: 			"delegation",
		name: 			"Prozesse der Medikationsverordnung mit Entscheidungsunterstützung",
		status: 		"not_started",
		assessment: 	"HhoSAanfneFrKeASrw8",
		message:		"Diese Fragen entziehen sich meiner Kenntnis", 
		members: 		["colleague3"], 
	}
]


const actions = {
// TODO - REPLACE WITH DB FUNCTION
	removeMember( {state}, {collab_id, member_id} ){
		var collab = state.find( c => c.id == collab_id );
		collab.members = collab.members.filter( m => m !== member_id )
		return true;
	},
	add({state}, collab ){
		state.push( collab	);
		return true;
	},
	getOne(){

	}
} 

const mutations = {}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
